import { AlertController, LoadingController, ModalController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { CommonProvider } from '../commonServices/common';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { AuthenticationService } from 'src/authentication-service';
import { PlayerInfo } from 'src/data/player-data';
import { PlayerService } from 'src/providers/player-service/player-service';
import { SessionDataService } from 'src/redux/session/session-data-service';
import { SessionInfo } from 'src/data/authentication-info';
import { Router } from '@angular/router';
import { Location } from '@angular/common';


@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.page.html',
    styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage implements OnInit {
    player: any;
    public openedModal: boolean = false;
    password: string;
    password1: string;
    password2: string;
    loggedInPassword: string;
    constructor(
        public navParams: NavParams,
        public nav: NavController,
        private keyboard: Keyboard,
        private renderer: Renderer2,
        private alertCtl: AlertController,
        private loaderCtl: LoadingController,
        private toastCtl: ToastController,
        private playerService: PlayerService,
        private auth: AuthenticationService,
        private sessionService: SessionDataService,
        private platform: Platform,
        private router: Router,
        public sessionDataService: SessionDataService,
        private modalCtl: ModalController,
        private Location: Location,

    ) {

        this.sessionDataService.getCurrentUser()
            .subscribe((currUser: any) => {

                this.player = currUser
            });
        this.openedModal = navParams.get("openedModal") ? navParams.get("openedModal") : false
    }

    async ngOnInit() {


    }

    async changePassword() {
        let session: any = this.sessionService.getSession().toPromise();
        this.loggedInPassword = session.password;

        if (this.platform.is('ios') && this.platform.is('capacitor'))
            this.keyboard.hide();
        if (!this.password || !this.password1 || !this.password2) {
            let subTitle = "Please enter all fields";
            MessageDisplayUtil.displayErrorAlert(this.alertCtl, "", subTitle, "OK");
            return false;
        }

        if (this.password1 !== this.password2) {
            let subTitle = "The New Password does not match";
            MessageDisplayUtil.displayErrorAlert(this.alertCtl, "", subTitle, "OK");
            return false;
        }

        if (this.password === this.password1) {
            let subTitle = "Please use different new password. ";
            MessageDisplayUtil.displayErrorAlert(this.alertCtl, "", subTitle, "OK");
            return false;
        }

        if (this.password1 && this.password1 === this.password2) {

            let loading = await this.loaderCtl.create({
                message: "Changing password. Please wait...",
                showBackdrop: false
            });

            await loading.present().then(() => {
                this.playerService.changePassword(this.player.userName, this.password, this.password1)
                    .subscribe((msg: string) => {

                        // this._showAlert(msg, true);
                        loading.dismiss().then(() => {
                            this.password = null,
                                this.password1 = null,
                                this.password2 = null,

                                MessageDisplayUtil.showMessageToast(msg, this.platform,
                                    this.toastCtl, 2000, "bottom");
                            this.router.navigate(['tabs/profile'])
                        })
                    }, (error) => {
                        loading.dismiss().then(() => {
                            let msg = MessageDisplayUtil.getErrorMessage(error, "Error occured while changing " +
                                " the password. Connection to server may be down.");
                            MessageDisplayUtil.showErrorToast(msg, this.platform,
                                this.toastCtl, 5000, "bottom");
                        });
                    });
            });

        }
    }
    backRouting() {
        if (this.openedModal) {
            this.modalCtl.dismiss(null, null, "changePassword")
        } else {
            this.Location.back();
        }
    }

}
